export default {
	SELECTED_PROGRAM: 'selectedProgram',
	SETTINGS: "settings",
	REDUX_STATE: "reduxState",
	PRIVILEGES: "privileges",
	REPORT_FILTERS: "reportFilters"
};